import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";
import { IAvaliableGamesByWager, IJackpotInfo } from "../pages/NewJackpot";

export async function getJackpotsList(params: any){
    let res = [
      {
        id: "",
        templateId: "",
        games: "",
        name: "",
        type: "",
        pct: "",
        houseSeed: "",
        status: "",
        houseContrib: "",
        playerContrib: "",
        addition: "",
        partialPrize: "",
        total: ""
      }
    ]
    params = removeEmpty(params)
    await Api.get(endpoints.getJackpotsList, {params}).then((response) => {
      if(response.status === 200 && response.data) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              res = response.data.list
          }
      }  else {
        notificationError('Could not get jackpots list')
      }
    }).catch((err: string) => {
      notificationError('Could not get jackpots list')
    })
    
    return res
}
export async function getJackpotsById(params: any){
    let res: IJackpotInfo = {
      name:"",
      houseSeed:"$0.00",
      contributionPercent:"0",
      wagerText:"$0",
      gameIds:[],
      instanceId:"",
      templateId:"",
      currentValue: "",
      active:true,
      additions:[]
    }
    params = removeEmpty(params)
    await Api.get(endpoints.getJackpotById, {params}).then((response) => {
      if(response.status === 200 && response.data) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              res = response.data
          }
      }  else {
        notificationError('Could not get jackpot')
      }
    }).catch((err: string) => {
      notificationError('Could not get jackpot')
    })
    
    return res
}

export async function getAvaliableGamesWithWager(){
  let res: IAvaliableGamesByWager = {}
  await Api.get(endpoints.getAvaliableGamesWithWager).then((response) => {
    if(response.status === 200 && response.data) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          res = response.data
        }
    }  else {
      notificationError('Could not get avaliable games list')
    }
  }).catch((err: string) => {
    notificationError('Could not get avaliable games list')
  })
  
  return res
}

export async function saveJackpot(params: any){
  let res = false
  await Api.post(endpoints.saveJackpot, params).then((response) => {
    if(response.status === 200 && response.data) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          res = true
          notificationSucces('Jackpot saved')
        }
    }  else {
      notificationError('Could not save jackpot')
    }
  }).catch((err: string) => {
    notificationError('Could not save jackpot')
  })
  
  return res
}

export async function addAddition(params: any){
  let res = false
  await Api.post(endpoints.addAddition, params).then((response) => {
    if(response.status === 200 && response.data) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          res = true
          notificationSucces('Addition saved')
        }
    }  else {
      notificationError('Could not save Addition')
    }
  }).catch((err: string) => {
    notificationError('Could not save Addition')
  })
  
  return res
}

export async function changeJackpotStatusById(params: any){
  let res = false
  await Api.get(endpoints.changeJackpotStatusById, {params}).then((response) => {
    if(response.status === 200 && response.data) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          res = true
          notificationSucces('Status saved')
        }
    }  else {
      notificationError('Could not save Status')
    }
  }).catch((err: string) => {
    notificationError('Could not save Status')
  })
  
  return res
}